module.exports = __webpack_public_path__ + "static/media/loader-bg.a1e2a885.svg";